import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

type Flags = { [key: string]: boolean };

@Injectable()
export class FeatureFlagsService {
    private loaded = false;
    private flagsSubject = new BehaviorSubject<Flags>({});
    flags: Observable<Flags> = this.flagsSubject;

    constructor(private http: HttpClient) {}

    async fetchFlags() {
        if (this.loaded) {
            return;
        }
        this.http
            .get<Flags>(`/api/feature-flags`)
            .subscribe((flagValues) => this.flagsSubject.next(flagValues));
        this.loaded = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/feature-flags.service.ts